import Button from "react-bootstrap/Button";
import './index.css'

interface ButtonComponentProps {
    title?: string;
    isDisabled?: boolean;
    type?: any;
    onClick?: any;
    icon?: any;
    backgroundColor?: string;
    color?: string;
}

const ButtonComponent: React.FC<ButtonComponentProps> = ({ title, isDisabled, type, onClick, icon,backgroundColor,color }) => {
    return (<>
        <Button className='buttonColor m-1 px-3' disabled={isDisabled} type={type} onClick={onClick}
        style={{backgroundColor:backgroundColor,color:color}}>
            <div className="d-flex align-items-center justify-content-space-between gap-2 p-0">
                {title}{icon}
            </div>
        </Button>
    </>)
}

export default ButtonComponent;